import { StripePaymentProcessorTypes } from './StripePaymentProcessor.js'
import { PaypalPaymentProcessorTypes } from './PaypalPaymentProcessor.js'

export interface PaymentProcessorAPI {

}

export interface PaymentProcessorOptions {}

export interface PaymentProcessorEncryptor {}

export type PaymentProcessorTypes = StripePaymentProcessorTypes | PaypalPaymentProcessorTypes

/**
 * represents a payment provider
 */
export enum PaymentProcessorClasses {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL'
}

export abstract class PaymentProcessor {
  public abstract isInitializing: boolean
  public abstract initialized: boolean

  protected abstract processorType: PaymentProcessorTypes
  protected abstract processorKey: string
  protected abstract processorOptions: any
  protected abstract processorAPI: PaymentProcessorAPI

  public abstract fetchProcessor (
    processorType: PaymentProcessorTypes,
    processorKey: string,
    processorOptions: PaymentProcessorOptions,
    onProcessorLoad: () => void
  ): Promise<PaymentProcessor>

  protected abstract initialize (options: PaymentProcessorOptions): void
  protected abstract onScriptLoad (): void
  protected abstract getToken(tokenInput: any, options: any): Promise<PaymentProcessorEncryptor>

  // common, but not required
  protected onProcessorLoad?: () => void = () => {}

  /**
   * returns a promise that will resolve whenever the processor API is initialized
   * will reject with error if initialization takes longer than the given timeout
   * if processor is already initialized, the promise will resolve immediately
   * @param timeout: number
   */
  getAPI: (timeout?: number) => Promise<PaymentProcessorAPI> = (timeout = 30000) => {
    const start: number = Date.now()

    const waitForInitialization = (resolve: any, reject: any) => {
      if (this.initialized) {
        resolve(this.processorAPI)
      } else if ((Date.now() - start) >= timeout) {
        reject(new Error('PaymentProcessor::getAPI() timeout'))
      } else {
        setTimeout(
          function() {
            waitForInitialization(resolve, reject)
          },
          30
        )
      }
    }

    return new Promise(waitForInitialization)
  }

  /**
   * returns a promise that will resolve whenever the processor API is ready
   * @param timeout: number
   */
  waitUntilReady: (timeout?: number) => Promise<boolean> = (timeout = 5000) => {
    return new Promise((resolve, reject) => {
      this.getAPI(timeout)
      .then(() => resolve(true))
      .catch(() => {
        reject(new Error('PaymentProcessor::waitUntilReady() timeout'))
      })
    })
  }
}
